import React from "react";
import classNames from "classnames";
import Panel from "./Panel";

const DisplayBox = ({ title, children, className, ...props }) => {
  return (
    <div className={classNames("display-box", className)} {...props}>
      {title && <h4 className="display-box-title">{title}</h4>}
      {children}
    </div>
  );
};

export default DisplayBox;
